import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";
import { TrendChart } from "./TrendChart.js";

export function PageLeadership({user,myVulns,setExportOpen}){
  var T=React.useContext(ThemeCtx).T;
  var _data=useState(null); var data=_data[0]; var setData=_data[1];
  var _loading=useState(true); var loading=_loading[0]; var setLoading=_loading[1];

  useEffect(function(){
    api.get("/leadership/summary")
      .then(function(d){setData(d);setLoading(false);})
      .catch(function(e){console.error(e);setLoading(false);});
  },[]);
  var _camps=useState([]); var camps=_camps[0]; var setCamps=_camps[1];
  var _campBd=useState([]); var campBd=_campBd[0]; var setCampBd=_campBd[1];
  var _ctab=useState("campaigns"); var ctab=_ctab[0]; var setCtab=_ctab[1];
  var _snapshots=useState([]); var snapshots=_snapshots[0]; var setSnapshots=_snapshots[1];
  var _snapA=useState(""); var snapA=_snapA[0]; var setSnapA=_snapA[1];
  var _snapB=useState(""); var snapB=_snapB[0]; var setSnapB=_snapB[1];
  var _ageView=useState("all"); var ageView=_ageView[0]; var setAgeView=_ageView[1];
  useEffect(function(){
    api.get("/campaigns").then(setCamps).catch(function(){});
    api.get("/campaigns/burndown/all").then(setCampBd).catch(function(){});
    api.get("/leadership/snapshots").then(function(rows){
      setSnapshots(rows||[]);
      if((rows||[]).length>=2){setSnapA(rows[1].snap_date);setSnapB(rows[0].snap_date);}
      else if((rows||[]).length===1){setSnapA(rows[0].snap_date);setSnapB(rows[0].snap_date);}
    }).catch(function(){});
  },[]);


  var PURPLE="#A100FF"; var ORANGE="#f97316"; var RED="#ef4444";
  var GREEN="#22c55e"; var BLUE="#3b82f6"; var AMBER="#f59e0b";
  var CHART_COLORS=["#A100FF","#f97316","#3b82f6","#22c55e","#f59e0b","#ec4899","#14b8a6","#8b5cf6","#06b6d4","#84cc16"];

  var KPICard=function(props){
    var delta=props.delta;
    var isGood=props.goodDown?(delta<0):(delta>0);
    var sparkData=props.sparkData||[];
    var PURPLE="#A100FF";
    return React.createElement("div",{style:{background:T.card,border:"0.5px solid "+T.border,
      borderRadius:8,padding:"12px 14px",minWidth:0,boxShadow:T.cardShadow,
      position:"relative",overflow:"hidden"}},
      React.createElement("div",{style:{position:"absolute",top:0,left:0,right:0,height:2,background:props.color||PURPLE}}),
      React.createElement("div",{style:{fontSize:9,color:T.text3,textTransform:"uppercase",
        letterSpacing:1.2,fontWeight:600,marginBottom:6}},props.label),
      React.createElement("div",{style:{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8}},
        React.createElement("div",null,
          React.createElement("div",{style:{fontSize:28,fontWeight:500,color:props.color||T.text,lineHeight:1,fontFamily:"'JetBrains Mono',monospace"}},props.value),
          props.sub&&React.createElement("div",{style:{fontSize:10,color:"#e5534b",marginTop:4,fontWeight:600}},props.sub),
          delta!==null&&delta!==undefined&&React.createElement("div",{
            style:{fontSize:11,color:isGood?"#2ea043":"#e5534b",marginTop:6,display:"flex",alignItems:"center",gap:3}},
            React.createElement("span",null,isGood?"▼":"▲"),
            Math.abs(delta)," vs last month"
          )
        ),
        sparkData.length>1&&React.createElement("svg",{width:80,height:36,viewBox:"0 0 80 36"},
          React.createElement("polyline",{
            fill:"none",
            stroke:props.color||PURPLE,
            strokeWidth:2,
            strokeLinecap:"round",
            strokeLinejoin:"round",
            points:(function(){
              var min=Math.min.apply(null,sparkData);
              var max=Math.max.apply(null,sparkData);
              var range=max-min||1;
              return sparkData.map(function(v,i){
                var x=(i/(sparkData.length-1))*76+2;
                var y=34-((v-min)/range)*30;
                return x.toFixed(1)+","+y.toFixed(1);
              }).join(" ");
            })()
          })
        )
      )
    );
  };

  if(loading) return React.createElement("div",{style:{color:T.text3,padding:40,textAlign:"center",fontSize:13}},"Loading leadership data...");
  if(!data)   return React.createElement("div",{style:{color:T.danger,padding:40,textAlign:"center",fontSize:13}},"Failed to load data");

  var k=data.kpis||{};
  var sc=data.scanStats||{};

  // Simple bar chart using divs (no recharts dependency issues)
  var SimpleBar=function(props){
    var max=Math.max.apply(null,props.data.map(function(d){return d[props.val]||0;}))||1;
    return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:6}},

      props.data.slice(0,8).map(function(d,i){
        var v=d[props.val]||0;
        var pct=Math.round((v/max)*100);
        return React.createElement("div",{key:i,style:{display:"flex",alignItems:"center",gap:8}},
          React.createElement("div",{style:{width:100,fontSize:11,color:T.text2,textAlign:"right",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flexShrink:0}},d[props.labelKey||props.label||Object.keys(d).find(function(k){return k!=="total"&&k!=="critical"&&k!=="high"&&k!=="medium"&&k!=="low";})||"name"]||"Unknown"),
          React.createElement("div",{style:{flex:1,height:18,background:T.inset,position:"relative"}},
            React.createElement("div",{style:{width:pct+"%",height:"100%",background:props.color||PURPLE,transition:"width .4s"}}),
            React.createElement("div",{style:{position:"absolute",right:4,top:1,fontSize:10,color:T.text,fontWeight:600}},v)
          )
        );
      })
    );
  };

  // Line sparkline using SVG
  var Sparkline=function(props){
    var pts=props.data||[];
    if(!pts.length) return null;
    var vals=pts.map(function(p){return p[props.val]||0;});
    var max=Math.max.apply(null,vals)||1;
    var min=Math.min.apply(null,vals)||0;
    var W=props.width||200; var H=props.height||50;
    var points=vals.map(function(v,i){
      var x=pts.length===1?W/2:(i/(pts.length-1))*W;
      var y=H-((v-min)/(max-min||1))*(H-8)-4;
      return x+","+y;
    }).join(" ");
    return React.createElement("svg",{width:W,height:H,style:{overflow:"visible"}},
      React.createElement("polyline",{points:points,fill:"none",stroke:props.color||PURPLE,strokeWidth:2}),
      vals.map(function(v,i){
        var x=pts.length===1?W/2:(i/(pts.length-1))*W;
        var y=H-((v-min)/(max-min||1))*(H-8)-4;
        return React.createElement("circle",{key:i,cx:x,cy:y,r:3,fill:props.color||PURPLE});
      })
    );
  };

  // Donut chart using SVG
  var Donut=function(props){
    var total=props.data.reduce(function(s,d){return s+(d.value||0);},0)||1;
    var R=props.r||60; var cx=props.cx||70; var cy=props.cy||70;
    var stroke=R*0.55;
    var circumference=2*Math.PI*R;
    var offset=0;
    var slices=props.data.map(function(d,i){
      var pct=(d.value||0)/total;
      var dasharray=pct*circumference+" "+(1-pct)*circumference;
      var s=React.createElement("circle",{key:i,cx:cx,cy:cy,r:R,fill:"none",
        stroke:CHART_COLORS[i%CHART_COLORS.length],strokeWidth:stroke,
        strokeDasharray:dasharray,strokeDashoffset:-offset*circumference,
        style:{transition:"stroke-dasharray .4s"}
      });
      offset+=pct;
      return s;
    });
    return React.createElement("svg",{width:cx*2,height:cy*2},
      slices,
      React.createElement("text",{x:cx,y:cy,textAnchor:"middle",dominantBaseline:"middle",fontSize:18,fontWeight:800,fill:T.text},total),
      React.createElement("text",{x:cx,y:cy+18,textAnchor:"middle",dominantBaseline:"middle",fontSize:9,fill:T.text3},"TOTAL")
    );
  };

  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:14}},

    // Row 0 — VM risk KPIs
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:8}},
      [
        {label:"Total Assets",    value:sc.total_assets||0,                                    color:PURPLE},
        {label:"Critical Assets", value:sc.critical_assets||0,                                 color:RED},
        {label:"Internet Facing", value:sc.internet_facing||0,                                 color:"#dc2626"},
        {label:"No Owner (Vulns)",value:sc.no_owner_vulns||myVulns.filter(function(v){return !v.owner_id&&v.status!=="Remediated"&&v.status!=="Exception";}).length, color:ORANGE},
        {label:"High EPSS",       value:sc.high_epss||myVulns.filter(function(v){return parseFloat(v.epss||0)>0.5&&v.status!=="Remediated"&&v.status!=="Exception";}).length, color:AMBER},
      ].map(function(item){
        return React.createElement("div",{key:item.label,style:{background:item.color,padding:"14px 16px",color:"#fff"}},
          React.createElement("div",{style:{fontSize:10,letterSpacing:1.5,textTransform:"uppercase",fontWeight:700,opacity:.85,marginBottom:4}},item.label),
          React.createElement("div",{style:{fontSize:28,fontWeight:800,lineHeight:1}},item.value)
        );
      })
    ),

    // Row 1 — Vuln KPI tiles
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:8}},
      [
        {label:"Total Vulns",   value:k.total?.value||0,      color:BLUE,   delta:k.total?.delta,      goodDown:true,
          sparkData:(k.snapshots||[]).map(function(s){return s.total||0;})},
        {label:"Critical",      value:k.critical?.value||0,   color:RED,    delta:k.critical?.delta,   goodDown:true,
          sub:myVulns.filter(function(v){return v.severity==="Critical"&&(v.days_left||0)<0&&v.status!=="Remediated";}).length+" past SLA",
          sparkData:(k.snapshots||[]).map(function(s){return s.critical||0;})},
        {label:"High",          value:k.high?.value||0,       color:ORANGE},
        {label:"Overdue",       value:k.overdue?.value||0,    color:AMBER,  delta:k.overdue?.delta,    goodDown:true},
        {label:"Remediated",    value:k.remediated?.value||0, color:GREEN,  delta:k.remediated?.delta, goodDown:false},
        {label:"Exceptions",    value:k.exceptions?.value||0, color:"#8b5cf6", delta:k.exceptions?.delta, goodDown:false},
        {label:"Avg Days to Fix", value:(function(){
          var rem=myVulns.filter(function(v){
            return v.status==="Remediated"&&v.remediated_at&&v.created_at&&
              new Date(v.remediated_at)>new Date(v.created_at);
          });
          if(!rem.length) return "—";
          var avg=rem.reduce(function(s,v){
            var days=Math.floor((new Date(v.remediated_at)-new Date(v.created_at))/(1000*60*60*24));
            return s+Math.max(0,days);
          },0)/rem.length;
          return Math.round(avg)+"d";
        })(), color:"#388bfd", goodDown:true,
          sparkData:(k.snapshots||[]).map(function(s){return s.remediated||0;})},
      ].map(function(item){
        return React.createElement(KPICard,Object.assign({key:item.label},item));
      })
    ),

    // Agent Status row — left: activity+cards, right: escalation+SLA+health+today
    React.createElement("div",{style:{background:T.card,border:"0.5px solid "+T.border,
      borderRadius:8,overflow:"hidden"}},
      React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8,
        padding:"10px 14px",borderBottom:"0.5px solid "+T.border}},
        React.createElement("div",{style:{fontSize:9,fontWeight:600,color:T.text3,
          textTransform:"uppercase",letterSpacing:1,flex:1}},"Agent status"),
        React.createElement("div",{style:{display:"flex",alignItems:"center",gap:4,fontSize:9,color:GREEN}},
          React.createElement("div",{style:{width:5,height:5,borderRadius:"50%",background:GREEN}}),
          "live"
        )
      ),
      React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:0}},
        React.createElement("div",{style:{borderRight:"0.5px solid "+T.border,padding:"12px 14px",
          display:"flex",flexDirection:"column",gap:12}},
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:10,fontWeight:600,color:T.text,marginBottom:8}},"Agent activity"),
            React.createElement("div",{style:{paddingLeft:14,position:"relative"}},
              React.createElement("div",{style:{position:"absolute",left:4,top:2,bottom:2,width:0.5,background:T.border}}),
              (data&&data.agentLog&&data.agentLog.length>0?data.agentLog:
               [{dot:"#22c55e",time:"--:--",agent:"System",msg:"AVTA running — "+((data&&data.kpis&&data.kpis.total&&data.kpis.total.value)||0)+" vulnerabilities tracked."}]
              ).map(function(fi,i){
                return React.createElement("div",{key:i,style:{position:"relative",marginBottom:i<4?8:0}},
                  React.createElement("div",{style:{position:"absolute",left:-11,top:4,width:6,height:6,
                    borderRadius:"50%",background:fi.dot+"22",border:"0.5px solid "+fi.dot}}),
                  React.createElement("div",{style:{fontSize:9,color:T.text3,fontFamily:"monospace",marginBottom:1}},fi.time),
                  React.createElement("div",{style:{fontSize:11,color:T.text2,lineHeight:1.4}},
                    React.createElement("strong",{style:{color:T.text,fontWeight:500}},fi.agent),
                    " \u2014 "+fi.msg)
                );
              })
            )
          ),
          React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7,flex:1}},
            [{name:"SLA Monitor",desc:"Hourly breach detection and alerts",status:"Active",
              stats:[{v:String((data&&data.kpis&&data.kpis.overdue&&data.kpis.overdue.value)||0),l:"breached",c:ORANGE},{v:"0",l:"near-breach",c:AMBER},{v:"hourly",l:"checks",c:T.text3}]},
             {name:"Risk Analyser",desc:"CVSS + EPSS contextual scoring per asset",status:"Active",
              stats:[{v:String((data&&data.kpis&&data.kpis.critical&&data.kpis.critical.value)||0),l:"critical",c:RED},{v:String((data&&data.kpis&&data.kpis.total&&data.kpis.total.value)||0),l:"total",c:BLUE},{v:"live",l:"scoring",c:T.text3}]},
             {name:"Auto Notifier",desc:"Primary \u2192 L4 escalation emails",status:"Active",
              stats:[{v:"0",l:"notified",c:BLUE},{v:"0",l:"escalated",c:ORANGE},{v:"0",l:"sent",c:T.text3}]},
             {name:"Report Generator",desc:"Excel, PDF and PPT export on demand",status:"Active",
              stats:[{v:"OK",l:"status",c:GREEN},{v:"PDF",l:"format",c:T.text3},{v:"live",l:"data",c:T.text3}]},
            ].map(function(ag){
              var sc={Active:GREEN,Idle:AMBER,Error:RED}[ag.status]||T.text3;
              return React.createElement("div",{key:ag.name,style:{background:T.inset,
                border:"0.5px solid "+T.border,borderRadius:7,padding:"10px 12px",
                display:"flex",flexDirection:"column",justifyContent:"space-between"}},
                React.createElement("div",null,
                  React.createElement("div",{style:{display:"flex",alignItems:"center",
                    justifyContent:"space-between",marginBottom:4}},
                    React.createElement("span",{style:{fontSize:11,fontWeight:500,color:T.text}},ag.name),
                    React.createElement("div",{style:{width:6,height:6,borderRadius:"50%",background:sc,flexShrink:0}})
                  ),
                  React.createElement("div",{style:{fontSize:10,color:T.text2,marginBottom:10,lineHeight:1.4}},ag.desc)
                ),
                React.createElement("div",{style:{display:"flex",gap:10}},
                  ag.stats.map(function(s){
                    return React.createElement("div",{key:s.l},
                      React.createElement("div",{style:{fontFamily:"monospace",fontSize:14,fontWeight:500,color:s.c,lineHeight:1}},s.v),
                      React.createElement("div",{style:{fontSize:8,color:T.text3,marginTop:2}},s.l)
                    );
                  })
                )
              );
            })
          )
        ),
        React.createElement("div",{style:{padding:"12px 14px",display:"flex",flexDirection:"column",gap:10}},
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:9,fontWeight:600,color:T.text3,
              textTransform:"uppercase",letterSpacing:.7,marginBottom:7}},"Escalation summary \u2014 today"),
            [{dot:BLUE,lbl:"Primary \u2014 notified",val:0,c:BLUE},
             {dot:"#8b5cf6",lbl:"Level 1 \u2014 follow-up",val:0,c:"#8b5cf6"},
             {dot:ORANGE,lbl:"Level 2 \u2014 breach",val:0,c:ORANGE},
             {dot:RED,lbl:"Level 3 \u2014 escalated",val:0,c:RED},
             {dot:"#7c2d12",lbl:"Level 4 \u2014 executive",val:0,c:RED},
            ].map(function(e,i){
              return React.createElement("div",{key:i,style:{display:"flex",alignItems:"center",gap:6,marginBottom:i<4?5:0}},
                React.createElement("div",{style:{width:6,height:6,borderRadius:"50%",background:e.dot,flexShrink:0}}),
                React.createElement("span",{style:{fontSize:10,color:T.text2,flex:1}},e.lbl),
                React.createElement("span",{style:{fontFamily:"monospace",fontSize:11,fontWeight:500,color:e.c}},e.val)
              );
            })
          ),
          React.createElement("div",{style:{height:0.5,background:T.border}}),
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:9,fontWeight:600,color:T.text3,
              textTransform:"uppercase",letterSpacing:.7,marginBottom:7}},"Top SLA breaches"),
            (data&&data.topBreaches&&data.topBreaches.length>0
              ?data.topBreaches.map(function(b){return {id:b.id,desc:(b.title||"").slice(0,38)+"\u2014"+(b.asset||""),days:"-"+(b.days_overdue||0)+"d"};})
              :[{id:"\u2014",desc:"No SLA breaches \u2014 all vulnerabilities within SLA",days:""}]
            ).map(function(v,i){
              return React.createElement("div",{key:i,style:{display:"flex",alignItems:"center",gap:7,
                padding:"5px 7px",background:T.inset,borderRadius:5,marginBottom:i<2?4:0}},
                React.createElement("span",{style:{fontFamily:"monospace",fontSize:10,color:BLUE,fontWeight:500,width:50,flexShrink:0}},v.id),
                React.createElement("span",{style:{fontSize:10,color:T.text,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},v.desc),
                React.createElement("span",{style:{fontFamily:"monospace",fontSize:10,fontWeight:600,color:RED,flexShrink:0}},v.days)
              );
            })
          ),
          React.createElement("div",{style:{height:0.5,background:T.border}}),
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:9,fontWeight:600,color:T.text3,
              textTransform:"uppercase",letterSpacing:.7,marginBottom:7}},"System health"),
            React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5}},
              [{name:"API Server",status:"OK",color:GREEN},{name:"Database",status:"OK",color:GREEN},
               {name:"nginx",status:"OK",color:GREEN},{name:"Bedrock AI",status:(data&&data.bedrockStatus)||"Unknown",color:(data&&data.bedrockStatus)==="OK"?GREEN:(data&&data.bedrockStatus)==="Slow"?AMBER:T.text3},
              ].map(function(h){
                return React.createElement("div",{key:h.name,style:{display:"flex",alignItems:"center",
                  gap:6,padding:"5px 8px",background:T.inset,borderRadius:5}},
                  React.createElement("div",{style:{width:6,height:6,borderRadius:"50%",background:h.color,flexShrink:0}}),
                  React.createElement("span",{style:{fontSize:10,color:T.text,flex:1}},h.name),
                  React.createElement("span",{style:{fontSize:9,fontWeight:500,color:h.color}},h.status)
                );
              })
            ),
            React.createElement("div",{style:{display:"flex",alignItems:"center",gap:6,
              padding:"5px 8px",background:T.inset,borderRadius:5,marginTop:5}},
              React.createElement("div",{style:{width:6,height:6,borderRadius:"50%",background:GREEN,flexShrink:0}}),
              React.createElement("span",{style:{fontSize:10,color:T.text,flex:1}},"Last sync"),
              React.createElement("span",{style:{fontSize:9,color:T.text3,fontFamily:"monospace"}},
                new Date().toISOString().slice(0,16).replace("T"," ")+" UTC")
            )
          ),
          React.createElement("div",{style:{height:0.5,background:T.border}}),
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:9,fontWeight:600,color:T.text3,
              textTransform:"uppercase",letterSpacing:.7,marginBottom:7}},"Today's summary"),
            React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6}},
              (data&&data.todaySummary
                ?[{v:(data.todaySummary.new_vulns>0?"+":"")+data.todaySummary.new_vulns,l:"new vulns",c:RED},
                  {v:"+"+data.todaySummary.closed,l:"closed",c:GREEN},
                  {v:(data.todaySummary.net_change>=0?"+":"")+data.todaySummary.net_change,l:"net change",c:ORANGE},
                  {v:data.todaySummary.emails_sent||0,l:"emails sent",c:BLUE}]
                :[{v:"0",l:"new vulns",c:RED},{v:"0",l:"closed",c:GREEN},{v:"0",l:"net change",c:ORANGE},{v:"0",l:"emails sent",c:BLUE}]
              ).map(function(s){
                return React.createElement("div",{key:s.l,style:{background:T.inset,borderRadius:5,
                  padding:"7px 6px",textAlign:"center"}},
                  React.createElement("div",{style:{fontFamily:"monospace",fontSize:16,fontWeight:500,color:s.c,lineHeight:1}},s.v),
                  React.createElement("div",{style:{fontSize:8,color:T.text3,marginTop:3}},s.l)
                );
              })
            )
          )
        )
      )
    ),

    // Row 2 — Charts row 1
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}},

      // Open Vuln Trend
      React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,padding:"14px 16px"}},
        React.createElement("div",{style:{fontSize:12,fontWeight:700,color:T.text,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}},"Open Vulnerability Trend"),
        data.trend&&data.trend.length>0
          ? React.createElement("div",{style:{padding:"8px 0"}},
              React.createElement(Sparkline,{data:data.trend,val:"total",color:PURPLE,width:280,height:80}),
              React.createElement("div",{style:{display:"flex",justifyContent:"space-between",fontSize:10,color:T.text3,marginTop:4}},
                React.createElement("span",null,data.trend[0]?.week||""),
                React.createElement("span",null,data.trend[data.trend.length-1]?.week||"")
              ),
              React.createElement("div",{style:{display:"flex",gap:12,marginTop:8}},
                [{val:"critical",color:RED,label:"Critical"},{val:"high",color:ORANGE,label:"High"}].map(function(s){
                  return React.createElement("div",{key:s.val,style:{display:"flex",alignItems:"center",gap:4,fontSize:11}},
                    React.createElement("div",{style:{width:10,height:3,background:s.color}}),
                    React.createElement("span",{style:{color:T.text3}},s.label)
                  );
                })
              )
            )
          : React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:20}},"No trend data yet")
      ),

      // Remediation Trend
      React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,padding:"14px 16px"}},
        React.createElement("div",{style:{fontSize:12,fontWeight:700,color:T.text,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}},"Remediation Trend"),
        data.remTrend&&data.remTrend.length>0
          ? React.createElement("div",null,
              React.createElement(Sparkline,{data:data.remTrend,val:"critical",color:RED,width:280,height:80}),
              React.createElement("div",{style:{display:"flex",justifyContent:"space-between",fontSize:10,color:T.text3,marginTop:4}},
                React.createElement("span",null,data.remTrend[0]?.month||""),
                React.createElement("span",null,data.remTrend[data.remTrend.length-1]?.month||"")
              )
            )
          : React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:20}},"Remediate vulns to see trend")
      ),

      // Ageing
      React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,padding:"14px 16px"}},
        React.createElement("div",{style:{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}},
          React.createElement("div",{style:{fontSize:12,fontWeight:700,color:T.text,textTransform:"uppercase",letterSpacing:.5}},"Ageing"),
          React.createElement("div",{style:{display:"flex",gap:2,background:T.inset,borderRadius:6,padding:2}},
            [["all","All"],["os","OS/Infra"],["app","App/Code"]].map(function(opt){
              return React.createElement("button",{key:opt[0],onClick:function(){setAgeView(opt[0]);},
                style:{padding:"3px 8px",fontSize:10,fontWeight:ageView===opt[0]?700:400,border:"none",borderRadius:4,cursor:"pointer",fontFamily:"inherit",
                  background:ageView===opt[0]?"#A100FF":"transparent",color:ageView===opt[0]?"#fff":T.text3}},opt[1]);
            })
          )
        ),
        data.ageing&&data.ageing.length>0
          ? (function(){var _SORD=["Critical","High"];var _SCOL={"Critical":"#ef4444","High":"#f97316"};return _SORD.map(function(sev){var a=data.ageing.find(function(x){return x.severity===sev;})||{severity:sev};
              var d0=ageView==="os"?Number(a.os_0_30||0):ageView==="app"?Number(a.app_0_30||0):Number(a.days_0_30||0);
              var d1=ageView==="os"?Number(a.os_31_60||0):ageView==="app"?Number(a.app_31_60||0):Number(a.days_31_60||0);
              var d2=ageView==="os"?Number(a.os_60_plus||0):ageView==="app"?Number(a.app_60_plus||0):Number(a.days_60_plus||0);
              var total=(d0+d1+d2)||1; var _sc=_SCOL[sev]||"#94a3b8";
              return React.createElement("div",{key:a.severity,style:{marginBottom:12}},
                React.createElement("div",{style:{fontSize:11,fontWeight:700,color:_sc,marginBottom:4}},sev),
                React.createElement("div",{style:{display:"flex",height:16,gap:1,overflow:"hidden"}},
                  [{v:d0,c:GREEN,l:"<30d"},{v:d1,c:ORANGE,l:"31-60d"},{v:d2,c:RED,l:">60d"}].map(function(seg){
                    var pct=Math.round((Number(seg.v)||0)/total*100);
                    return pct>0?React.createElement("div",{key:seg.l,style:{width:pct+"%",background:seg.c,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#fff",fontWeight:700}},pct>10?pct+"%":""):null;
                  })
                ),
                React.createElement("div",{style:{display:"flex",gap:10,marginTop:3}},
                  [{v:d0,c:GREEN,l:"<30d"},{v:d1,c:ORANGE,l:"31-60d"},{v:d2,c:RED,l:">60d"}].map(function(seg){
                    return React.createElement("div",{key:seg.l,style:{display:"flex",alignItems:"center",gap:3,fontSize:10}},
                      React.createElement("div",{style:{width:8,height:8,background:seg.c}}),
                      React.createElement("span",{style:{color:T.text3}},seg.l+": "),
                      React.createElement("span",{style:{fontWeight:600,color:T.text}},seg.v||0)
                    );
                  })
                )
              );
            });})()
          : React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:20}},"No open vulns")
      )
    ),

    // Tabbed chart panel — Active Campaigns / Age / By Platform / Pod Burndown
    (function(){
      var tabs=[
        {id:"campaigns",  label:"Active Campaigns"},
        {id:"age",        label:"Open by Age"},
        {id:"platform",   label:"By Platform"},
        {id:"burndown",   label:"Pod Burndown"},
        {id:"comparison", label:"📅 Scan Comparison"},
      ];
      var tabBtn=function(t){
        return React.createElement("button",{key:t.id,onClick:function(){setCtab(t.id);},
          style:{padding:"7px 14px",border:"none",background:"transparent",cursor:"pointer",
            fontSize:11,fontWeight:ctab===t.id?600:400,fontFamily:"inherit",
            color:ctab===t.id?PURPLE:T.text3,
            borderBottom:ctab===t.id?"2px solid "+PURPLE:"2px solid transparent",
            marginBottom:-0.5}},t.label);
      };
      return React.createElement("div",{style:{background:T.card,border:"0.5px solid "+T.border,borderRadius:8,overflow:"hidden"}},
        // Tab strip
        React.createElement("div",{style:{display:"flex",borderBottom:"0.5px solid "+T.border,padding:"0 14px",gap:2}},
          tabs.map(tabBtn)
        ),
        // Tab content
        React.createElement("div",{style:{padding:"14px 16px"}},

          // ── Active Campaigns ──────────────────────────────────────────
          ctab==="campaigns"&&(function(){
            var active=camps.filter(function(c){return c.status==="Active";});
            if(!active.length) return React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:20}},"No active campaigns");
            var maxTotal=Math.max.apply(null,active.map(function(c){return c.total_vulns||0;}).concat([1]));
            return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
              active.slice(0,8).map(function(c){
                var pct=c.total_vulns>0?Math.round((c.remediated_vulns/c.total_vulns)*100):0;
                var widthPct=Math.round(((c.total_vulns||0)/maxTotal)*100);
                return React.createElement("div",{key:c.id,style:{display:"flex",alignItems:"center",gap:8,cursor:"pointer"},
                  onClick:function(){setPage("remediation");}},
                  React.createElement("div",{style:{width:140,fontSize:11,color:T.text2,textAlign:"right",
                    overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flexShrink:0}},c.name),
                  React.createElement("div",{style:{flex:1,height:18,background:T.inset,position:"relative"}},
                    React.createElement("div",{style:{width:widthPct+"%",height:"100%",background:PURPLE,transition:"width .4s",position:"relative"}},
                      React.createElement("div",{style:{position:"absolute",top:0,left:0,height:"100%",width:pct+"%",background:GREEN,opacity:.55}})
                    )
                  ),
                  React.createElement("div",{style:{width:84,fontSize:10,color:T.text,fontWeight:600,flexShrink:0,whiteSpace:"nowrap",textAlign:"right"}},
                    c.remediated_vulns+"/"+c.total_vulns+" · "+pct+"%"),
                  c.due_date&&React.createElement("div",{style:{width:54,fontSize:9,color:T.text3,flexShrink:0,whiteSpace:"nowrap"}},
                    "Due "+new Date(c.due_date).toLocaleDateString("en-GB",{day:"2-digit",month:"short"}))
                );
              }),
              React.createElement("div",{style:{display:"flex",gap:16,paddingTop:8,borderTop:"0.5px solid "+T.border}},
                [{v:active.length,l:"active",c:PURPLE},{v:camps.filter(function(c){return c.status==="Completed";}).length,l:"completed",c:GREEN},
                 {v:camps.filter(function(c){return c.status==="On Hold";}).length,l:"on hold",c:AMBER},
                 {v:active.reduce(function(s,c){return s+(Number(c.total_vulns)||0);},0),l:"total vulns tracked",c:T.text3}
                ].map(function(s){
                  return React.createElement("div",{key:s.l},
                    React.createElement("div",{style:{fontFamily:"monospace",fontSize:18,fontWeight:500,color:s.c}},s.v),
                    React.createElement("div",{style:{fontSize:9,color:T.text3}},s.l)
                  );
                })
              )
            );
          })(),

          // ── Open by Age ───────────────────────────────────────────────
          ctab==="age"&&(function(){
            var ag=data.ageing||[];
            var tot0=ag.reduce(function(s,a){return s+Number(a.days_0_30||0);},0);
            var tot1=ag.reduce(function(s,a){return s+Number(a.days_31_60||0);},0);
            var tot2=ag.reduce(function(s,a){return s+Number(a.days_60_plus||0);},0);
            var grandTotal=(tot0+tot1+tot2)||1;
            var buckets=[
              {lbl:"< 30 days",  val:tot0, c:GREEN},
              {lbl:"31–60 days", val:tot1, c:AMBER},
              {lbl:"> 60 days",  val:tot2, c:RED},
            ];
            var SEV_ORDER=["Critical","High","Medium","Low"];
            var SEV_COLORS={"Critical":RED,"High":ORANGE,"Medium":AMBER,"Low":GREEN};
            var agSorted=SEV_ORDER.map(function(s){return ag.find(function(a){return a.severity===s;})||{severity:s,days_0_30:0,days_31_60:0,days_60_plus:0,os_0_30:0,os_31_60:0,os_60_plus:0,app_0_30:0,app_31_60:0,app_60_plus:0};});
            var agAll=agSorted;
            var critRow=agSorted[0]; var highRow=agSorted[1]; var medRow=agSorted[2]; var lowRow=agSorted[3];
            var critTotal=(Number(critRow.days_0_30||0)+Number(critRow.days_31_60||0)+Number(critRow.days_60_plus||0));
            var highTotal=(Number(highRow.days_0_30||0)+Number(highRow.days_31_60||0)+Number(highRow.days_60_plus||0));
            var medTotal=(Number(medRow.days_0_30||0)+Number(medRow.days_31_60||0)+Number(medRow.days_60_plus||0));
            var lowTotal=(Number(lowRow.days_0_30||0)+Number(lowRow.days_31_60||0)+Number(lowRow.days_60_plus||0));
            var sevTotal=(critTotal+highTotal+medTotal+lowTotal)||1;
            var allSevColors={"Critical":RED,"High":ORANGE,"Medium":AMBER,"Low":GREEN};
            return React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24}},
              React.createElement("div",null,
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text,marginBottom:10}},"By age bucket"),
                buckets.map(function(r){
                  var pct=Math.round((r.val/grandTotal)*100);
                  return React.createElement("div",{key:r.lbl,style:{display:"flex",alignItems:"center",gap:8,marginBottom:7}},
                    React.createElement("span",{style:{fontSize:10,color:T.text2,width:72,flexShrink:0}},r.lbl),
                    React.createElement("div",{style:{flex:1,height:7,background:T.inset,borderRadius:3,overflow:"hidden"}},
                      React.createElement("div",{style:{height:7,width:pct+"%",background:r.c,borderRadius:3}})
                    ),
                    React.createElement("span",{style:{fontSize:10,color:T.text3,fontFamily:"monospace",width:24,textAlign:"right"}},r.val)
                  );
                })
              ),
              React.createElement("div",null,
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text,marginBottom:10}},"Severity split"),
                React.createElement("div",{style:{display:"flex",height:22,borderRadius:5,overflow:"hidden",marginBottom:8}},
                  [{f:critTotal,c:RED},{f:highTotal,c:ORANGE},{f:medTotal,c:AMBER},{f:lowTotal,c:GREEN}].map(function(s,i){
                    return s.f>0?React.createElement("div",{key:i,style:{flex:s.f,background:s.c,display:"flex",
                      alignItems:"center",justifyContent:"center",fontSize:9,color:"#fff",fontWeight:600}},s.f):null;
                  })
                ),
                React.createElement("div",{style:{display:"flex",gap:10,marginBottom:14}},
                  [{c:RED,l:"Critical",v:critTotal},{c:ORANGE,l:"High",v:highTotal},{c:AMBER,l:"Medium",v:medTotal},{c:GREEN,l:"Low",v:lowTotal}].map(function(s){
                    return React.createElement("div",{key:s.l,style:{display:"flex",alignItems:"center",gap:4,fontSize:9,color:T.text2}},
                      React.createElement("div",{style:{width:6,height:6,borderRadius:"50%",background:s.c}}),
                      s.l+": "+s.v);
                  })
                ),
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text,marginBottom:8}},"Age breakdown by severity"),
                agAll.map(function(a){
                  var t=(Number(a.days_0_30||0)+Number(a.days_31_60||0)+Number(a.days_60_plus||0))||1;
                  return React.createElement("div",{key:a.severity,style:{marginBottom:8}},
                    React.createElement("div",{style:{fontSize:10,fontWeight:700,color:allSevColors[a.severity]||T.text3,marginBottom:3}},a.severity),
                    React.createElement("div",{style:{display:"flex",height:10,gap:1,borderRadius:3,overflow:"hidden"}},
                      [{v:Number(a.days_0_30||0),c:GREEN},{v:Number(a.days_31_60||0),c:AMBER},{v:Number(a.days_60_plus||0),c:RED}].map(function(seg,i){
                        var pct=Math.round((seg.v/t)*100);
                        return pct>0?React.createElement("div",{key:i,style:{width:pct+"%",background:seg.c,display:"flex",alignItems:"center",justifyContent:"center",fontSize:8,color:"#fff",fontWeight:700}},pct>12?pct+"%":""):null;
                      })
                    ),
                    React.createElement("div",{style:{display:"flex",gap:8,marginTop:2}},
                      [{v:Number(a.days_0_30||0),c:GREEN,l:"<30d"},{v:Number(a.days_31_60||0),c:AMBER,l:"31-60d"},{v:Number(a.days_60_plus||0),c:RED,l:">60d"}].map(function(seg){
                        return React.createElement("span",{key:seg.l,style:{fontSize:9,color:T.text3}},seg.l+": ",React.createElement("strong",{style:{color:T.text}},seg.v));
                      })
                    )
                  );
                })
              )
            );
          })(),

          // ── By Platform ───────────────────────────────────────────────
          ctab==="platform"&&React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24}},
            React.createElement("div",null,
              React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text,marginBottom:10}},"By platform"),
              data.byPlatform&&data.byPlatform.length>0
                ? React.createElement(SimpleBar,{data:data.byPlatform,labelKey:"platform",val:"total",color:PURPLE})
                : React.createElement("div",{style:{color:T.text3,fontSize:12}},"No data")
            ),
            React.createElement("div",null,
              React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text,marginBottom:10}},"Top vulnerable assets"),
              data.topAssets&&data.topAssets.length>0
                ? React.createElement(SimpleBar,{data:data.topAssets,labelKey:"asset",val:"total",color:RED})
                : React.createElement("div",{style:{color:T.text3,fontSize:12}},"No data")
            )
          ),

          // ── Pod Burndown ──────────────────────────────────────────────
          ctab==="burndown"&&(function(){
            var pb=data.podBurndown||[];
            if(!pb.length) return React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:20}},"No burndown data yet");
            var weeks=Array.from(new Set(pb.map(function(r){return r.week;})));
            var pods=Array.from(new Set(pb.map(function(r){return r.pod;})));
            var palette=[PURPLE,ORANGE,BLUE,GREEN];
            var podColors={};
            pods.forEach(function(p,i){podColors[p]=palette[i%palette.length];});
            var maxVal=Math.max.apply(null,pb.map(function(r){return Number(r.open_count)||0;}).concat([1]));
            var W=680,H=140,padL=28,padB=18;
            var stepX=(W-padL)/Math.max(1,weeks.length-1);
            var toY=function(v){return H-padB-(v/maxVal)*(H-padB-8);};
            var lines=pods.map(function(pod){
              var pts=weeks.map(function(wk,i){
                var row=pb.find(function(r){return r.week===wk&&r.pod===pod;});
                var v=row?Number(row.open_count):0;
                return (padL+i*stepX).toFixed(1)+","+toY(v).toFixed(1);
              }).join(" ");
              return {pod:pod,points:pts,color:podColors[pod]};
            });
            return React.createElement("div",null,
              React.createElement("svg",{width:"100%",height:H,viewBox:"0 0 "+W+" "+H,preserveAspectRatio:"none"},
                [0,0.5,1].map(function(f){
                  var y=H-padB-f*(H-padB-8);
                  return React.createElement("line",{key:f,x1:padL,y1:y,x2:W,y2:y,stroke:T.border,strokeWidth:0.5});
                }),
                React.createElement("text",{x:2,y:H-padB+4,fontSize:8,fill:T.text3},"0"),
                React.createElement("text",{x:2,y:12,fontSize:8,fill:T.text3},maxVal),
                lines.map(function(l){
                  return React.createElement("polyline",{key:l.pod,fill:"none",stroke:l.color,strokeWidth:2,
                    strokeLinecap:"round",strokeLinejoin:"round",points:l.points});
                }),
                lines.map(function(l){
                  var last=l.points.split(" ").pop().split(",");
                  return React.createElement("circle",{key:l.pod+"-dot",cx:last[0],cy:last[1],r:3,fill:l.color});
                })
              ),
              React.createElement("div",{style:{display:"flex",justifyContent:"space-between",fontSize:9,color:T.text3,marginTop:2,paddingLeft:padL}},
                React.createElement("span",null,weeks[0]||""),
                React.createElement("span",null,weeks[weeks.length-1]||"")
              ),
              React.createElement("div",{style:{display:"flex",gap:14,marginTop:8,flexWrap:"wrap"}},
                pods.map(function(pod){
                  var latest=pb.filter(function(r){return r.pod===pod;}).slice(-1)[0];
                  return React.createElement("div",{key:pod,style:{display:"flex",alignItems:"center",gap:5,fontSize:11}},
                    React.createElement("div",{style:{width:10,height:3,background:podColors[pod],borderRadius:1}}),
                    React.createElement("span",{style:{color:T.text2}},pod),
                    React.createElement("span",{style:{color:T.text,fontWeight:700}},latest?latest.open_count:"0")
                  );
                })
              )
            );
          })(),

          ctab==="comparison"&&(function(){
            var FIELDS=[
              {key:"total",     label:"Total Vulns",  goodDown:true},
              {key:"critical",  label:"Critical",     goodDown:true},
              {key:"high",      label:"High",         goodDown:true},
              {key:"medium",    label:"Medium",       goodDown:true},
              {key:"low",       label:"Low",          goodDown:false},
              {key:"overdue",   label:"Overdue",      goodDown:true},
              {key:"remediated",label:"Remediated",   goodDown:false},
              {key:"exceptions",label:"Exceptions",   goodDown:false},
            ];
            var snapA_data=snapshots.find(function(s){return s.snap_date===snapA;})||{};
            var snapB_data=snapshots.find(function(s){return s.snap_date===snapB;})||{};
            var fmtDate=function(d){return d?d.toString().slice(0,10):"—";};
            var selStyle={padding:"5px 8px",fontSize:11,background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,outline:"none",fontFamily:"inherit"};
            return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
              React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}},
                React.createElement("div",{style:{fontSize:11,color:T.text2,fontWeight:600}},"Compare:"),
                React.createElement("select",{value:snapA,onChange:function(e){setSnapA(e.target.value);},style:selStyle},
                  snapshots.map(function(s){return React.createElement("option",{key:s.snap_date,value:s.snap_date},fmtDate(s.snap_date)+" ("+s.total+" vulns)");})),
                React.createElement("span",{style:{color:T.text3,fontSize:11}},"vs"),
                React.createElement("select",{value:snapB,onChange:function(e){setSnapB(e.target.value);},style:selStyle},
                  snapshots.map(function(s){return React.createElement("option",{key:s.snap_date,value:s.snap_date},fmtDate(s.snap_date)+" ("+s.total+" vulns)");}))
              ),
              snapshots.length===0
                ? React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:20}},"No snapshots yet — snapshots are taken daily at midnight")
                : React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:12}},
                    React.createElement("thead",null,
                      React.createElement("tr",{style:{background:T.inset}},
                        ["Metric",fmtDate(snapA),fmtDate(snapB),"Change"].map(function(h){
                          return React.createElement("th",{key:h,style:{padding:"8px 10px",textAlign:h==="Metric"?"left":"center",fontSize:10,fontWeight:700,color:T.text3,textTransform:"uppercase",letterSpacing:.8,borderBottom:"1px solid "+T.border}},h);
                        })
                      )
                    ),
                    React.createElement("tbody",null,
                      FIELDS.map(function(f,i){
                        var vA=Number(snapA_data[f.key]||0);
                        var vB=Number(snapB_data[f.key]||0);
                        var diff=vB-vA;
                        var improved=(f.goodDown&&diff<0)||(!f.goodDown&&diff>0);
                        var worsened=(f.goodDown&&diff>0)||(!f.goodDown&&diff<0);
                        var diffColor=improved?"#22c55e":worsened?"#ef4444":T.text3;
                        var diffStr=diff===0?"—":(diff>0?"+":"")+diff;
                        var diffIcon=diff===0?"":improved?"▼ ":"▲ ";
                        return React.createElement("tr",{key:f.key,style:{background:i%2===0?"transparent":T.inset+"44",borderBottom:"1px solid "+T.border}},
                          React.createElement("td",{style:{padding:"8px 10px",fontWeight:600,color:T.text}},f.label),
                          React.createElement("td",{style:{padding:"8px 10px",textAlign:"center",color:T.text2}},vA),
                          React.createElement("td",{style:{padding:"8px 10px",textAlign:"center",color:T.text2}},vB),
                          React.createElement("td",{style:{padding:"8px 10px",textAlign:"center",color:diffColor,fontWeight:700}},diffIcon+diffStr)
                        );
                      })
                    )
                  )
            );
          })(),
        )
      );
    })(),

    // Row 3 — Charts row 2
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}},

      // By Environment (donut)
      React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,padding:"14px 16px"}},
        React.createElement("div",{style:{fontSize:12,fontWeight:700,color:T.text,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}},"Top 10 Asset Environments"),
        data.byEnv&&data.byEnv.length>0
          ? React.createElement("div",{style:{display:"flex",alignItems:"center",gap:16}},
              React.createElement(Donut,{data:data.byEnv.map(function(e){return{name:e.env,value:Number(e.total)};})
              }),
              React.createElement("div",{style:{flex:1}},
                data.byEnv.map(function(e,i){
                  return React.createElement("div",{key:e.env,style:{display:"flex",alignItems:"center",gap:6,marginBottom:5,fontSize:11}},
                    React.createElement("div",{style:{width:10,height:10,background:CHART_COLORS[i%CHART_COLORS.length],flexShrink:0}}),
                    React.createElement("span",{style:{color:T.text2,flex:1}},e.env),
                    React.createElement("span",{style:{fontWeight:700,color:T.text}},e.total)
                  );
                })
              )
            )
          : React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:20}},"No data")
      ),

      // Top 10 Vulnerable Apps (donut)
      React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,padding:"14px 16px"}},
        React.createElement("div",{style:{fontSize:12,fontWeight:700,color:T.text,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}},"Top 10 Vulnerable Assets"),
        data.topApps&&data.topApps.length>0
          ? React.createElement("div",{style:{display:"flex",alignItems:"center",gap:12}},
              React.createElement(Donut,{data:data.topApps.map(function(a){return{name:a.name,value:Number(a.value)};}),r:50,cx:60,cy:60}),
              React.createElement("div",{style:{flex:1}},
                data.topApps.slice(0,6).map(function(a,i){
                  return React.createElement("div",{key:a.name,style:{display:"flex",alignItems:"center",gap:6,marginBottom:4,fontSize:10}},
                    React.createElement("div",{style:{width:8,height:8,background:CHART_COLORS[i%CHART_COLORS.length],flexShrink:0}}),
                    React.createElement("span",{style:{color:T.text2,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},a.name),
                    React.createElement("span",{style:{fontWeight:700,color:T.text}},a.value)
                  );
                })
              )
            )
          : React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:20}},"No data")
      )
    ),



    // Row 4 — Top assets table
    React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,padding:"14px 16px"}},
      React.createElement("div",{style:{fontSize:12,fontWeight:700,color:T.text,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}},"Top Vulnerable Assets"),
      React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
        React.createElement("thead",null,
          React.createElement("tr",{style:{background:T.inset}},
            ["Asset","Environment","Critical","High","Total"].map(function(h){
              return React.createElement("th",{key:h,style:{padding:"8px 12px",textAlign:"left",fontSize:10,fontWeight:700,color:T.text3,textTransform:"uppercase",letterSpacing:.8}},h);
            })
          )
        ),
        React.createElement("tbody",null,
          (data.topAssets||[]).map(function(a,i){
            return React.createElement("tr",{key:a.asset,style:{borderTop:"1px solid "+T.border,background:i%2===0?"transparent":T.inset+"44"}},
              React.createElement("td",{style:{padding:"7px 12px",fontSize:12,fontWeight:600,color:PURPLE}},a.asset),
              React.createElement("td",{style:{padding:"7px 12px",fontSize:11,color:T.text3}},a.env),
              React.createElement("td",{style:{padding:"7px 12px"}},
                a.critical>0&&React.createElement("span",{style:{background:RED+"22",color:RED,border:"1px solid "+RED+"44",padding:"2px 8px",fontSize:11,fontWeight:700}},a.critical)
              ),
              React.createElement("td",{style:{padding:"7px 12px"}},
                a.high>0&&React.createElement("span",{style:{background:ORANGE+"22",color:ORANGE,border:"1px solid "+ORANGE+"44",padding:"2px 8px",fontSize:11,fontWeight:700}},a.high)
              ),
              React.createElement("td",{style:{padding:"7px 12px",fontSize:12,fontWeight:700,color:T.text}},a.total)
            );
          })
        )
      )
    ),

    // Age Buckets + Category
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}},
      React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:12,padding:"16px 20px",boxShadow:T.cardShadow}},
        React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text,marginBottom:14}},"Open Findings by Age"),
        (function(){
          var now=new Date();
          var buckets=[
            {label:"Last 7 days", color:"#2ea043",count:myVulns.filter(function(v){return v.status!=="Remediated"&&(now-new Date(v.created_at))/(86400000)<=7;}).length},
            {label:"Last 30 days",color:"#388bfd",count:myVulns.filter(function(v){return v.status!=="Remediated"&&(now-new Date(v.created_at))/(86400000)<=30;}).length},
            {label:"Last 90 days",color:"#d29922",count:myVulns.filter(function(v){return v.status!=="Remediated"&&(now-new Date(v.created_at))/(86400000)<=90;}).length},
            {label:"90+ days",    color:"#e5534b",count:myVulns.filter(function(v){return v.status!=="Remediated"&&(now-new Date(v.created_at))/(86400000)>90;}).length},
          ];
          var mx=Math.max.apply(null,buckets.map(function(b){return b.count;})||[1]);
          return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
            buckets.map(function(b){
              return React.createElement("div",{key:b.label},
                React.createElement("div",{style:{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:4}},
                  React.createElement("span",{style:{color:T.text2}},b.label),
                  React.createElement("span",{style:{color:b.color,fontWeight:700}},b.count)),
                React.createElement("div",{style:{height:8,background:T.border,borderRadius:4}},
                  React.createElement("div",{style:{height:"100%",width:(mx>0?(b.count/mx)*100:0)+"%",background:b.color,borderRadius:4}}))
              );
            })
          );
        })()
      ),
      React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:12,padding:"16px 20px",boxShadow:T.cardShadow}},
        React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text,marginBottom:14}},"Findings by Category"),
        (function(){
          var cats={infra:{l:"Infrastructure",c:"#3b82f6"},sast:{l:"SAST",c:"#8b5cf6"},dast:{l:"DAST",c:"#ec4899"},container:{l:"Container",c:"#06b6d4"},sca:{l:"SCA",c:"#22c55e"},manual:{l:"Manual",c:"#f59e0b"},api:{l:"API",c:"#f97316"}};
          var data=Object.entries(cats).map(function(e){
            return {label:e[1].l,color:e[1].c,count:myVulns.filter(function(v){return (v.scan_type||"manual").toLowerCase()===e[0]&&v.status!=="Remediated";}).length};
          }).filter(function(d){return d.count>0;}).sort(function(a,b){return b.count-a.count;});
          var mx=Math.max.apply(null,data.map(function(d){return d.count;})||[1]);
          if(!data.length) return React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:20}},"No categorised findings");
          return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
            data.map(function(d){
              return React.createElement("div",{key:d.label},
                React.createElement("div",{style:{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:4}},
                  React.createElement("span",{style:{color:T.text2}},d.label),
                  React.createElement("span",{style:{color:d.color,fontWeight:700}},d.count)),
                React.createElement("div",{style:{height:8,background:T.border,borderRadius:4}},
                  React.createElement("div",{style:{height:"100%",width:(mx>0?(d.count/mx)*100:0)+"%",background:d.color,borderRadius:4}}))
              );
            })
          );
        })()
      )
    ),
    // Export button
    React.createElement("div",{style:{display:"flex",justifyContent:"flex-end"}},
      
    )
  );
}